import { apiClient } from "helpers/api_helper";

export const GetReturnSalesOrder = async (data: object) => {
    try {
        const response = await apiClient.get(`/api/v1/ReturnSalesOrder/GetReturnSalesOrder`,data);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};

export const GetReturnSalesOrderItemById = async (id: string) => {
    try {
        const response = await apiClient.get(`/api/v1/ReturnSalesOrder/GetReturnSalesOrderItemByReturnSalesOrderId?returnSalesOrderId=${id}`);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};